import { createFileRoute } from '@tanstack/react-router'
import { InternshipPlacePage } from '@/pages/internship-place/ui/InternshipPlacePage'

export const Route = createFileRoute('/my-workplace')({
  component: InternshipPlacePage,
})
